// extracted by mini-css-extract-plugin
module.exports = {"img":"DishImageMedium_img__EqSnC"};